module.exports = __webpack_public_path__ + "img/news.5a62edb9.svg";